import { ActionButton } from '@main/pc-core-components/src/ActionButton';
import {
  ActionButtonWrapper,
  PanelWrapper,
} from '@main/pc-core-components/src/DisplayActions/wrappers';
import type { PrivacyCenterWorkflowConfig } from '@main/pc-types';
import React from 'react';

import { takeControlMessages } from './messages';

interface DisplayWorkflowsProps {
  /** The configured workflows */
  workflows: PrivacyCenterWorkflowConfig[];
  /** The selected workflow */
  selectWorkflow: (workflow: PrivacyCenterWorkflowConfig) => void;
}

export const DisplayWorkflows: React.FC<
  React.PropsWithChildren<DisplayWorkflowsProps>
> = ({ workflows, selectWorkflow }) => (
  <PanelWrapper>
    {workflows.map((workflow) => (
      <ActionButtonWrapper key={workflow.id}>
        <ActionButton
          {...workflow.action}
          title={workflow.title}
          description={workflow.subtitle ?? takeControlMessages.noDescription}
          icon={workflow.action.icon}
          type={workflow.action.type}
          onClick={() => selectWorkflow(workflow)}
        />
      </ActionButtonWrapper>
    ))}
  </PanelWrapper>
);
